(function () {
  function getSectionId() {
    const firstSlide = document.querySelector('[data-media-id]');
    if (!firstSlide) return null;
    const val = firstSlide.dataset.mediaId;
    const lastDash = val.lastIndexOf('-');
    return lastDash > -1 ? val.substring(0, lastDash) : null;
  }

  function buildSlideMediaId(sectionPrefix, numericId) {
    return `${sectionPrefix}-${numericId}`;
  }

  function filterMediaByVariant(variant) {
    const mediaGallery = document.querySelector('media-gallery');
    if (!mediaGallery) return;

    const allSlides = mediaGallery.querySelectorAll('[data-media-id]');
    if (!allSlides.length) return;

    if (!variant || !variant.featured_media) {
      allSlides.forEach((slide) => { slide.style.display = ''; });
      filterThumbnails(null);
      return;
    }

    const productJSON = getProductJSON();
    if (!productJSON) return;

    const sectionPrefix = getSectionId();
    if (!sectionPrefix) return;

    const numericMediaIds = getVariantNumericMediaIds(productJSON, variant.id);
    const slideMediaIds = numericMediaIds.map((id) => buildSlideMediaId(sectionPrefix, id));

    allSlides.forEach((slide) => {
      const slideId = slide.dataset.mediaId;
      if (!slideId) { slide.style.display = ''; return; }
      slide.style.display = slideMediaIds.includes(slideId) ? '' : 'none';
    });

    filterThumbnails(slideMediaIds);

    const featuredId = buildSlideMediaId(sectionPrefix, variant.featured_media.id);
    const featuredSlide = mediaGallery.querySelector(`[data-media-id="${featuredId}"]`);
    if (featuredSlide) {
      featuredSlide.parentElement.scrollTo({ left: featuredSlide.offsetLeft });
    }
  }

  function filterThumbnails(slideMediaIds) {
    const thumbnails = document.querySelectorAll('[data-target]');
    thumbnails.forEach((thumb) => {
      const target = thumb.dataset.target;
      if (!target) return;
      if (!slideMediaIds) { thumb.style.display = ''; return; }
      thumb.style.display = slideMediaIds.includes(target) ? '' : 'none';
    });
  }

  function getProductJSON() {
  const scriptTag = document.getElementById('xcotton_pp_variants');
  if (!scriptTag) return null;
  try { return JSON.parse(scriptTag.textContent); } catch (e) { return null; }
}


  function getVariantNumericMediaIds(product, variantId) {
    const ids = new Set();
    const targetVariant = product.variants.find((v) => v.id === variantId);
    if (!targetVariant) return [];

    if (targetVariant.featured_media) {
      ids.add(targetVariant.featured_media.id);
    }

    if (product.media) {
      product.media.forEach((media) => {
        if (!media.alt) return;
        const altLower = media.alt.toLowerCase();
        if (targetVariant.title && altLower === targetVariant.title.toLowerCase()) {
          ids.add(media.id);
        }
        if (targetVariant.options) {
          targetVariant.options.forEach((opt) => {
            if (altLower === opt.toLowerCase()) ids.add(media.id);
          });
        }
      });
    }

    return Array.from(ids);
  }

  function registerVariantListener() {
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      const variant = event && event.data && event.data.variant;
      filterMediaByVariant(variant);
    });
  } else {
    // subscribe 还未就绪，100ms 后重试
    setTimeout(registerVariantListener, 100);
  }
}

registerVariantListener();
})();

